import {
  Button as MuiButton,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  Typography as MuiTypography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";
import { AllowedTags } from "app/shared/constants";
import { StyleApp } from "app/shared/ui/ui.styles";

export const InfoDialog = ({ params, setParams }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setParams({ ...params, show: false });
  };

  return (
    <MuiDialog
      open={params.show}
      onClose={handleClose}
      scroll={"paper"}
      aria-labelledby="info-dialog-title"
      aria-describedby="info-dialog-description"
      fullWidth
    >
      <MuiDialogTitle
        id="info-dialog-title"
        sx={{ ...StyleApp.links, fontWeight: 500, fontSize: "18.75px" }}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              t("forms.infoDialog.title", { fieldName: params.fieldLabel }),
              {
                ALLOWED_TAGS: AllowedTags,
              },
            ),
          }}
        />
      </MuiDialogTitle>
      <MuiDialogContent dividers>
        <MuiTypography
          id="info-dialog-description"
          component="div"
          variant="body2"
          sx={StyleApp.links}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(params.fieldContent, {
                ALLOWED_TAGS: AllowedTags,
              }),
            }}
          />
        </MuiTypography>
      </MuiDialogContent>
      <MuiDialogActions>
        <MuiButton
          onClick={handleClose}
          color="primary"
          sx={{ fontSize: "17px" }}
        >
          {t("forms.infoDialog.button.close")}
        </MuiButton>
      </MuiDialogActions>
    </MuiDialog>
  );
};
